import React, { useState, useEffect, useCallback, useContext } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormatDateFormat } from "../../../utils/dateFormat";
import { getInitials, S2sEstimatedPayoutDetailsTable } from "./coxUtils";
import PayoutHistoryDetails from "./PayoutHistoryDetails";
import TiersDetails from "./TiersDetails";
import WorkOrderDetails from "./WorkOrderDetails";
import "../../../assets/css/coxModal.css";
import { formatCurrency } from "../../../utils";
import { AuthContext } from "../../../utils/CompanyContext";

const CoxIncentives2sModal = ({
  clickedRow,
  showModal,
  toggleModal,
  s2S_EstimatedPayoutDetails,
  get_WorkOrderDetails,
  get_PayoutHistory,
  get_TiersForAgent,
}) => {
  const [nestedModal, setNestedModal] = useState({
    isPayoutHistoryModal: false,
    isTiersModal: false,
    isWorkOrderModal: false,
  });
  const toggleNested = useCallback((modalName) => {
    setNestedModal((prevState) => ({
      ...prevState,
      [modalName]: !prevState[modalName],
    }));
  }, []);
  const { DefaultOrganization, Loginid } = useContext(AuthContext);

  const [data, setData] = useState([]);

  const [inputs, setInputs] = useState({
    anc: 0,
    psu: 0,
    wireless: 0,
  });

  const [loading, setLoading] = useState(false);
  const [hasCalculated, setHasCalculated] = useState(false);

  useEffect(() => {
    if (!showModal) {
      setHasCalculated(false);
      setData([]);
    }
  }, [showModal]);

  const [potential, setPotential] = useState({
    total: null,
    diff: null,
    state: "ideal", // ideal | green | red
  });

  const handleInputChange = (key, value) => {
    setInputs((prev) => ({ ...prev, [key]: Number(value) }));
  };

  /* -------------------- SHOW ME THE MONEY -------------------- */
  const handleShowMeTheMoney = async () => {
    setHasCalculated(true);
    const { anc, psu, wireless } = inputs;

    if (anc < 0 || psu < 0 || wireless < 0) {
      alert("Negative Numbers not allowed");
      return;
    }

    setLoading(true);
    setPotential({ total: null, diff: null, state: "ideal" });

    setTimeout(async () => {
      try {
        const res = await fetch(
          `https://amplifai-reactjs-webapi.azurewebsites.net/api/CoxIncentives/Calculate_S2S_PotentialPayout?` +
            new URLSearchParams({
              organization: DefaultOrganization,
              agentnetworkid: Loginid,
              anc_a_metric_value: 0,
              anc_b_metric_value: 0,
              ccc_metric_value: 0,
              mlg_metric_value: 0,
            }),
        );

        const data = await res.json();
        setData(data);

        let finalPayout = 0;
        data.forEach((d) => {
          finalPayout += d.metric_Value * d.pay_Rate;
        });

        const current = parseFloat(
          document
            .querySelector(".inc_dollar_s2s")
            ?.textContent.replace("$", ""),
        );

        let diff = finalPayout - current;
        let state = "ideal";
        let total = finalPayout;

        if (finalPayout > 0) {
          if (diff > 0) {
            state = "green";
          } else if (diff < 0) {
            state = "red";
          } else {
            // 👇 NO CHANGE CASE
            total = 0;
            state = "ideal";
          }
        } else {
          state = current > 0 ? "red" : "ideal";
          diff = Math.abs(current);
        }

        if (finalPayout > 0) {
          if (diff > 0) state = "green";
          else if (diff < 0) state = "red";
        } else {
          state = current > 0 ? "red" : "ideal";
          diff = Math.abs(current);
        }

        setPotential({
          total,
          diff: Math.abs(diff),
          state,
        });
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }, 3000);
  };

  /* -------------------- data -------------------- */

  const closeBtn = (
    <div
      className="links_right"
      style={{ position: "absolute", top: "15px", right: "15px" }}
    >
      <button
        className="modal_close bg-transparent"
        onClick={toggleModal}
        type="button"
      >
        <img src="/images/cross.svg" />
      </button>
    </div>
  );

  const getRateByIndex = (index) => {
    if (!hasCalculated) return "--.--";
    return data[index]?.pay_Rate ?? "--.--";
  };

  const getPotentialPayoutByIndex = (index, count) => {
    const rate = data[index]?.pay_Rate;
    if (!hasCalculated || rate === undefined) return "$--.--";
    return `$${(Number(count) * Number(rate)).toFixed(2)}`;
  };

  const { agent_Name, quarter, estimated_Payout, scorecards, results, date } =
    s2S_EstimatedPayoutDetails?.[0] || {};
  const initials = getInitials(agent_Name);
  // const initials = "";
  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      backdrop={true}
      keyboard={true}
      //   centered={true}
      id="cox_incentive"
      external={closeBtn}
      style={{
        maxWidth: "90%",
      }}
    >
      <ModalBody id="cox_incentive_s2s" className="p-0">
        {s2S_EstimatedPayoutDetails?.length > 0 ? (
          <div className="container-fluid">
            <div
              className="row"
              style={{
                backgroundColor: "#f5f8fa",
              }}
            >
              <div className="col-md-7 pr-0">
                <div className="inc_leftblock">
                  <div className="incentive_block1">
                    <div className="flex space-between align-start">
                      <div className="detail_block">
                        <div className="inc_profile flex align-start">
                          <div className="inc_name_letters">
                            <div className="fs">{initials}</div>
                          </div>
                          <div className="inc_name_details">
                            <div className="namee" id="agent_details">
                              {agent_Name}
                            </div>
                            <p
                              style={{
                                fontWeight: "600px",
                              }}
                            >
                              Agent
                            </p>
                          </div>
                        </div>
                        <div className="inc_month flex align-center">
                          <div className="">Month</div>
                          <div>:</div>
                          <div
                            style={{
                              padding: "5px",
                              fontWeight: "500",
                            }}
                          >
                            {FormatDateFormat(date, "MMMM")}{" "}
                            {FormatDateFormat(date, "YYYY")}
                          </div>
                        </div>
                      </div>
                      <div
                        className="estimate_block"
                        style={{ marginTop: "46px" }}
                      >
                        <div className="white_bg">
                          <div
                            className={`mb-10 ${
                              estimated_Payout > 0 ? "" : "inc_red"
                            }`}
                            style={{ fontWeight: "200" }}
                          >
                            Estimated Payout
                          </div>
                          <div
                            className={`inc_dollar_s2s ${
                              estimated_Payout > 0 ? "inc_green" : "inc_red"
                            }`}
                          >
                            {formatCurrency(estimated_Payout)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="incentive_block2"
                    style={{
                      marginBottom: "65px",
                    }}
                  >
                    <div className="table-responsive">
                      <table className="table tiles-table">
                        <thead>
                          <tr>
                            <th>Metric</th>
                            <th>Count</th>
                            <th>Rate</th>
                            <th>Estimated Payout</th>
                          </tr>
                        </thead>
                        <tbody>
                          {s2S_EstimatedPayoutDetails?.map((item, index) => (
                            <tr key={index}>
                              {/* Metric */}
                              <td>{item.type}</td>

                              {/* Count */}
                              <td>{item.metric_Value}</td>

                              {/* Rate */}
                              <td>{item.pay_Rate}</td>

                              {/* Estimated Payout */}
                              <td className="inc_red">$0.00</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 pr-0">
                <div
                  className="inc_right_block1"
                  style={{
                    marginTop: "8px",
                  }}
                >
                  <div
                    className="bgg"
                    style={{
                      marginTop: "-6px",
                    }}
                  >
                    <div className="pl-15">
                      <h3>Calculate Potential S2S Earnings</h3>
                      <div
                        className="pt-8 flex justify-content-center align-start"
                        style={{
                          marginBottom: "36px",
                        }}
                      >
                        {loading && (
                          <div className="show_money_gif">
                            <img src="/images/slotmachine.gif?2" width="180" />
                          </div>
                        )}

                        {!loading && potential.state === "ideal" && (
                          <div className="inc_potential_tile ideal">
                            <div>Potential Payout</div>

                            <div className="inc_val">
                              {!hasCalculated ? "$--.--" : `$0.00`}
                            </div>

                            {/* show only after calculation */}
                            {hasCalculated && (
                              <div className="payout_val">No Change</div>
                            )}
                          </div>
                        )}

                        {!loading && potential.state === "green" && (
                          <div className="inc_potential_tile green_tile">
                            <div className="headd">Potential Payout</div>
                            <div className="inc_val">
                              ${potential.total.toFixed(2)}
                            </div>
                            <div className="payout_val">
                              ↑ ${potential.diff.toFixed(2)}
                            </div>
                          </div>
                        )}

                        {!loading && potential.state === "red" && (
                          <div className="inc_potential_tile redd_tile">
                            <div className="headd">Potential Payout</div>
                            <div className="inc_val">
                              ${potential.total.toFixed(2)}
                            </div>
                            <div className="payout_val">
                              ↓ ${potential.diff.toFixed(2)}
                            </div>
                          </div>
                        )}

                        <div className="show_money_gif hid">
                          <img
                            src="/images/slotmachine.gif?2"
                            style={{ width: "180px" }}
                            alt="Slot Machine"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="potential_table">
                      <div className="table-responsive">
                        <table className="table tiles-table">
                          <thead>
                            <tr>
                              <th>New Count</th>
                              <th>New Rate</th>
                              <th>Potential Payout</th>
                            </tr>
                          </thead>
                          <tbody>
                            {s2S_EstimatedPayoutDetails?.map((item, index) => {
                              const count =
                                index === 0 ? inputs.anc : item.metric_Value;

                              return (
                                <tr key={index}>
                                  {/* NEW COUNT */}
                                  <td className="inc_input">
                                    {index === 0 ? (
                                      <input
                                        type="number"
                                        className="form-control"
                                        min="0"
                                        value={inputs.anc}
                                        onChange={(e) =>
                                          handleInputChange(
                                            "anc",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    ) : (
                                      <input
                                        type="number"
                                        className="form-control"
                                        value={item.metric_Value}
                                        readOnly
                                      />
                                    )}
                                  </td>

                                  {/* NEW RATE */}
                                  <td className="inc_input">
                                    {getRateByIndex(index)}
                                  </td>

                                  {/* POTENTIAL PAYOUT */}
                                  <td className="inc_input">
                                    {getPotentialPayoutByIndex(index, count)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="show_money">
                        <button
                          className="btn btn-primary"
                          id="calculate_potential_earn_s2s"
                          style={{ fontSize: 17, background: "#348bf2" }}
                          onClick={handleShowMeTheMoney}
                        >
                          Show Me the money
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="term_cond"
              style={{
                backgroundColor: "#f5f8fa",
              }}
            >
              <div
                className="row"
                style={{
                  marginTop: "-19px",
                }}
              >
                <div
                  className="col-md-7"
                  style={{ paddingRight: "0px", marginTop: "-48px" }}
                >
                  <div className="inc_terms_cond">
                    <div>
                      <strong class="disclaimer-heading">Disclaimer:</strong>
                      <ol class="disclaimer-list">
                        <li>
                          Please note that the data presented includes estimates
                          and is subject to change. While every effort is made
                          to ensure accuracy, updates, delays, and occasional
                          corrections may result in variations between the
                          figures shown here and those reported elsewhere. These
                          estimates are not intended to serve as a definitive
                          indication of the final payout for Service2Sales.
                        </li>
                        <li>
                          Eligibility for any Low-Value or CCC payout requires
                          the sale of at least one High-Value ancillary product.
                        </li>
                        <li>
                          A minimum of six CCC ancillary products must be sold
                          to qualify for the CCC payout.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="inc_details">
                    <div className="flex justify-content-end">
                      <div className="mr-5">
                        <a
                          className="btn btn-primary"
                          onClick={() => toggleNested("isWorkOrderModal")}
                          style={{
                            background: "#414d5a",
                            borderColor: "#414d5a",
                          }}
                        >
                          Work Order Details
                        </a>
                      </div>
                      <div className="mr-5">
                        <a
                          className="btn btn-primary"
                          onClick={() => toggleNested("isTiersModal")}
                          style={{
                            background: "#414d5a",
                            borderColor: "#414d5a",
                          }}
                        >
                          Tiers
                        </a>
                      </div>
                      <div className="mr-5">
                        <a
                          className="btn btn-primary"
                          onClick={() => toggleNested("isPayoutHistoryModal")}
                          style={{
                            background: "#414d5a",
                            borderColor: "#414d5a",
                          }}
                        >
                          Payout History
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="modal-dialog" style={{ fontSize: "80px" }}>
            <p>No Data</p>
          </div>
        )}
        {nestedModal.isPayoutHistoryModal && (
          <PayoutHistoryDetails
            rowData={get_PayoutHistory}
            showModal={nestedModal.isPayoutHistoryModal}
            toggleModal={() => toggleNested("isPayoutHistoryModal")}
          />
        )}
        {nestedModal.isTiersModal && (
          <TiersDetails
            rowData={get_TiersForAgent}
            showModal={nestedModal.isTiersModal}
            toggleModal={() => toggleNested("isTiersModal")}
          />
        )}
        {nestedModal.isWorkOrderModal && (
          <WorkOrderDetails
            rowData={get_WorkOrderDetails}
            showModal={nestedModal.isWorkOrderModal}
            toggleModal={() => toggleNested("isWorkOrderModal")}
          />
        )}
      </ModalBody>
    </Modal>
  );
};
export default CoxIncentives2sModal;
